import { render, staticRenderFns } from "./orders.component.vue?vue&type=template&id=8ee8e4a2&"
import script from "./orders.component.vue?vue&type=script&lang=ts&"
export * from "./orders.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "orders.component.vue"
export default component.exports